import ErrorIcon from '@/components/validation/ErrorIcon';
import { Severity } from '@/types/validation';
import { SvgIconComponent } from '@mui/icons-material';
import { Icon, Stack, Tooltip, useTheme } from '@mui/material';
import React, { FC } from 'react';

type TreeLabelProps = {
  icon: SvgIconComponent;
  label: React.ReactNode;
  iconColor?: string;
  tooltip?: string;
  error?: Severity;
  IconTitle?: string;
  onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
};

const TreeLabel: FC<TreeLabelProps> = (props) => {
  const theme = useTheme();
  return (
    <Tooltip title={props.tooltip} placement='right' arrow>
      <Stack direction='row' gap={1} alignItems='center'>
        <Tooltip title={props.IconTitle} placement='right' arrow>
          <Icon
            component={props.icon}
            fontSize='small'
            onClick={(event) => props.onClick && props.onClick(event)}
            sx={{
              opacity: 0.75,
              ...(props.iconColor && { color: props.iconColor }),
              '&:hover': props.onClick && { backgroundColor: theme.palette.action.hover }
            }}
          />
        </Tooltip>
        {props.label}
        {props.error && <ErrorIcon severity={props.error} color={props.error} fontSize='small' />}
      </Stack>
    </Tooltip>
  );
};

export default TreeLabel;
